import { ospThemes } from "@ospweb/sdk-ui";
import { SignalLevel } from "../DetailsCommon/Forecast/constants";
import { TAListType } from "./types";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/TA/const";

const I18n = I18nUtil.createScoped(Translations);

// 根据市场类型映射 agent_ids
export const AGENT_IDS_MAP: Record<TAListType, string[]> = {
  [TAListType.US_Market]: ["2"], // US Market 的 agent_id
  [TAListType.HK_Market]: ["2"], // HK Market 的 agent_id
  [TAListType.Crypto]: ["103"], // Crypto 的 agent_id，需要根据实际情况调整
};

// 信号等级配置
export const SIGNAL_LEVELS = [
  {
    key: SignalLevel.STRONG_SELL,
    label: "Strong Sell",
    bgColor: ospThemes.colors.background_accent2_overlay20,
    activeColor: ospThemes.colors.background_accent2_overlay100,
    activeBgColor: ospThemes.colors.background_accent2_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#FF4347]/10 to-[#FF4347]/0 to-96%",
  },
  {
    key: SignalLevel.SELL,
    label: "Sell",
    bgColor: ospThemes.colors.background_accent3_overlay20,
    activeColor: ospThemes.colors.background_accent3_overlay100,
    activeBgColor: ospThemes.colors.background_accent3_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#FD8016]/10 to-[#FD8016]/0 to-96%",
  },
  {
    key: SignalLevel.NEUTRAL,
    label: "Neutral",
    bgColor: ospThemes.colors.background_auralv3_overlay20,
    activeColor: ospThemes.colors.background_auralv3_overlay100,
    activeBgColor: ospThemes.colors.background_auralv3_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#FFFFB0]/10 to-[#FFFFB0]/0 to-96%",
  },
  {
    key: SignalLevel.BUY,
    label: "Buy",
    bgColor: ospThemes.colors.background_accent1_overlay20,
    activeColor: ospThemes.colors.background_accent1_overlay100,
    activeBgColor: ospThemes.colors.background_accent1_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#02D79B]/10 to-[#02D79B]/0 to-96%",
  },
  {
    key: SignalLevel.STRONG_BUY,
    label: "Strong Buy",
    bgColor: ospThemes.colors.background_accent1_overlay20,
    activeColor: ospThemes.colors.background_accent1_overlay100,
    activeBgColor: ospThemes.colors.background_accent1_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#02D79B]/10 to-[#02D79B]/0 to-96%",
  },
] as const;

/** 仅 Strong Buy / Strong Sell，用于列表/网格筛选 */
export const STRONG_SIGNAL_LEVELS = [
  SignalLevel.STRONG_BUY,
  SignalLevel.STRONG_SELL,
] as const;

// 信号等级翻译键映射（仅存储翻译键，不存储翻译结果）
export const TA_LEVEL_KEYS = {
  [SignalLevel.STRONG_SELL]: "Strong Sell",
  [SignalLevel.SELL]: "Sell",
  [SignalLevel.NEUTRAL]: "Neutral",
  [SignalLevel.BUY]: "Buy",
  [SignalLevel.STRONG_BUY]: "Strong Buy",
  ["any"]: "Any",
} as const;

// 获取信号等级的翻译文本
export const getTALevelLabel = (level: string | undefined): string => {
  if (!level) {
    return "";
  }
  const key = TA_LEVEL_KEYS[level as keyof typeof TA_LEVEL_KEYS];
  return key ? I18n.t(key) : "";
};
